import { browserTracingIntegration } from "@sentry/react";

const environment = process.env.REACT_APP_INNO_ENV || 'development';

// Mirror your server configuration
const environments = ['beta', 'development', 'staging', 'production', 'ci'];
const disableSentryEnvironments = ['development', 'staging', 'ci'];

if (!environments.includes(environment)) {
  throw new Error(`REACT_APP_INNO_ENV "${environment}" must be one of: ${environments.join(', ')}`);
}

const { REACT_APP_SENTRY_DSN: dsn = null } = process.env;
const config = { 
  dsn, 
  environment,
  integrations: [
    browserTracingIntegration(),
  ],
  tracesSampleRate: 0.05, // Match your server sampling rate
  beforeSend(event) {
    // Filter out common client errors you don't want to track
    const errorMessage = event.exception?.values?.[0]?.value || event.message || 'Unknown error';
    
    if (errorMessage.includes('ResizeObserver loop limit exceeded')) {
      return null;
    }
    
    if (errorMessage.includes('Non-Error promise rejection captured')) {
      return null;
    }
    
    return event;
  }
};

// Disable Sentry in certain environments
if (disableSentryEnvironments.includes(environment)) {
  config.dsn = null;
}

export default config;